import { useSelector } from 'react-redux';

export default function useSchemas() {
  const schemas = useSelector((state: any) => state.dataSetSchemas);

  function getNexsetSchemaById(nexsetId) {
    return schemas?.[nexsetId]?.out;
  }

  return {
    getNexsetSchemaById,
  };
}
